import { Typography } from '@mui/material'
import TimeManagementTabs from './TimeManagementTabs'
import styles from './styles.module.scss'
const TimeManagementScreen = () => {
	return (
		<div className={styles.pageWrap}>
			<div className={styles.pageHeader}>
				<Typography component="h1">Time Management</Typography>
			</div>

			<div className={styles.ProposalPageScreenMain}>
				<TimeManagementTabs />
			</div>
		</div>
	)
}

export default TimeManagementScreen
